<template>
  <div v-if="loading" class="page-center">
    <div class="page-center-box text-center">
      <ui-loading-page />
    </div>
  </div>
  <div v-else>
    <div class="d-flex align-items-center justify-content-between">
      <div class="me-2">
        <RouterLink
          class="btn btn-ghost btn-back"
          :to="'/leasings/' + route.params.id"
        >
          <LeftIcon class="icon" />
        </RouterLink>
      </div>
      <div class="flex-grow-1 page-title">Анкета лизингополучателя</div>
      <div class="ms-2" style="width: 36px"></div>
    </div>

    <div class="hr"></div>

    <div v-if="status > 0 && status < 10">
      <div class="login-alert p-3 text-center mt-4 mb-3">
        <div class="text-primary">Внимание!</div>
        <span>Документ принят! После проверки с вами свяжется менеджер.</span>
      </div>
    </div>

    <AppForm :data="data" :citizenshipList="[]" :uid="RID" :status="status" />
  </div>
</template>


<script setup>
import LeftIcon from "@/assets/svg/left.vue";
import { useRoute } from "vue-router";

import { onMounted, ref, onBeforeUnmount } from "vue";
import { postApi } from "@/run";

import AppForm from "./AppForm/index.vue";
// Получаем текущий маршрут
const route = useRoute();

const loading = ref(true);

const data = ref({});
const RID = ref(null);
const status = ref(null);

onMounted(() => {
  postApi("/leasing/application", {
    id: route.params.id,
  })
    .then((response) => {
      if (response.error) {
        error.value = response.error;
      }

      if (response?.anketa) {
        let ReqData = response.anketa?.ReqData
          ? JSON.parse(response.anketa.ReqData)
          : {};
        let ReqResponce = response.anketa?.ReqResponce
          ? JSON.parse(response.anketa.ReqResponce)
          : {};

        RID.value = response.anketa?.RID;
        status.value = response.anketa?.Status
          ? Number(response.anketa.Status)
          : 0;

        data.value = { ...ReqData, ...ReqResponce };
      }
    })
    .finally(() => {
      loading.value = false;
    });
});
</script>